import React, { useState, useEffect } from 'react';
import CompaniesList from './components/CompaniesList';
import ActionBar from '../layout/ActionBar';
import AddCompany from './slideout/AddCompany';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getAllCompanyTypes } from '../../reducers/companyTypeReducer';

function Companies() {
  const { t } = useTranslation();
  const companyTypes = useAppSelector((state) => state.companyTypes);
  const dispatch = useAppDispatch();

  usePageTitle(['All companies']);
  const [reload, setReload] = useState<any>();
  const [addCompanySlideoutOpen, setAddCompanySlideoutOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!companyTypes) {
      dispatch(getAllCompanyTypes());
    }
  }, [companyTypes, dispatch]);

  return (
    <>
      <ActionBar breadcrumb={[]}>
        <Button
          className="btn btn-primary"
          text={t('Add company')}
          onClick={() => setAddCompanySlideoutOpen(true)}
          testId="add-company-button"
        />
      </ActionBar>
      <CompaniesList reload={reload} companyTypes={companyTypes ?? undefined} />

      <SlidingPane
        isOpen={addCompanySlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddCompanySlideoutOpen(false)}
      >
        <AddCompany
          done={(savedCompany) => {
            if (savedCompany) {
              navigate(`/company/${savedCompany.id}`);
            }
            setAddCompanySlideoutOpen(false);
          }}
          cancel={() => setAddCompanySlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default Companies;
